import { render, staticRenderFns } from "./data-video.vue?vue&type=template&id=0facbe16&scoped=true"
import script from "./data-video.vue?vue&type=script&lang=js"
export * from "./data-video.vue?vue&type=script&lang=js"
import style0 from "./data-video.vue?vue&type=style&index=0&id=0facbe16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0facbe16",
  null
  
)

export default component.exports